import { ReferProps } from '../../interfaces/interfaces';

import './styles.scss';

export function ReferenceTwo({ id, sales }: ReferProps) {
  return (
    <div className="itens-container-reference2">
      <div className="author-wrapper-reference2">
        <div className="user-info-reference2">
          <span className="title-name2">
            {id}
          </span>
          <span className="title-sold2">
            {sales} {sales > 1 ? 'PARES' : 'PAR'}
          </span>
        </div>
      </div>
    </div>
  );
}